import Logo from '../../../assets/logo/logo.png'

const Rotate = props => {
    return <div className="container fluid py-2" id="rotate">

        <div className="container fluid">
            <p className="text xl"><a href="#rotate" className="link">&#128279;</a> Rotate</p>
            <p className="text md">
                Rotate classes applies <code>rotate</code> property to an element.
        </p>
        </div>

        <div className="spacer md"></div>

        <div className="container md">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.rotate5, .rotate10, .rotate20, .rotate30, .rotate40, .rotate50, .rotate60, .rotate70, .rotate80, .rotate90, .rotate100, .rotate110, .rotate120, .rotate130, .rotate140, .rotate150, .rotate160, .rotate170, .rotate180</code>
                            </td>
                            <td>Rotates an element to a positive degree</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Rotate the image</label>
                                    <select onChange={(e) => props.helper('rotate-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rotate5">.rotate5</option>
                                        <option value="rotate10">.rotate10</option>
                                        <option value="rotate20">.rotate20</option>
                                        <option value="rotate30">.rotate30</option>
                                        <option value="rotate40">.rotate40</option>
                                        <option value="rotate50">.rotate50</option>
                                        <option value="rotate60">.rotate60</option>
                                        <option value="rotate70">.rotate70</option>
                                        <option value="rotate80">.rotate80</option>
                                        <option value="rotate90">.rotate90</option>
                                        <option value="rotate100">.rotate100</option>
                                        <option value="rotate110">.rotate110</option>
                                        <option value="rotate120">.rotate120</option>
                                        <option value="rotate130">.rotate130</option>
                                        <option value="rotate140">.rotate140</option>
                                        <option value="rotate150">.rotate150</option>
                                        <option value="rotate160">.rotate160</option>
                                        <option value="rotate170">.rotate170</option>
                                        <option value="rotate180">.rotate180</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.rotate-5, .rotate-10, .rotate-20, .rotate-30, .rotate-40, .rotate-50, .rotate-60, .rotate-70, .rotate-80, .rotate-90, .rotate-100, .rotate-110, .rotate-120, .rotate-130, .rotate-140, .rotate-150, .rotate-160, .rotate-170, .rotate-180</code>
                            </td>
                            <td>Rotates an element to a negative degree</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Rotate the image</label>
                                    <select onChange={(e) => props.helper('rotate-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rotate-5">.rotate-5</option>
                                        <option value="rotate-10">.rotate-10</option>
                                        <option value="rotate-20">.rotate-20</option>
                                        <option value="rotate-30">.rotate-30</option>
                                        <option value="rotate-40">.rotate-40</option>
                                        <option value="rotate-50">.rotate-50</option>
                                        <option value="rotate-60">.rotate-60</option>
                                        <option value="rotate-70">.rotate-70</option>
                                        <option value="rotate-80">.rotate-80</option>
                                        <option value="rotate-90">.rotate-90</option>
                                        <option value="rotate-100">.rotate-100</option>
                                        <option value="rotate-110">.rotate-110</option>
                                        <option value="rotate-120">.rotate-120</option>
                                        <option value="rotate-130">.rotate-130</option>
                                        <option value="rotate-140">.rotate-140</option>
                                        <option value="rotate-150">.rotate-150</option>
                                        <option value="rotate-160">.rotate-160</option>
                                        <option value="rotate-170">.rotate-170</option>
                                        <option value="rotate-180">.rotate-180</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div className="container sm py-2">
            <div className="border-dark min-h25 align-items-center justify-content-center">
                <img src={Logo} alt="POKE-CSS-LOGO" style={{ width: '100px', height: '100px' }} id="rotate-display" />
            </div>
        </div>

    </div>
}

export default Rotate